import { render } from "./FotoTextoIzquierda.vue?vue&type=template&id=5058aea1"
import script from "./FotoTextoIzquierda.vue?vue&type=script&lang=js"
export * from "./FotoTextoIzquierda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__